import React from 'react';
import { Alert as AntdAlert, AlertProps as AntdAlertProps } from 'antd';
import cn from 'classnames';

import type { StatusColor } from 'admin/components/common/Tag';
import css from './Alert.scss';

type Props = AntdAlertProps & {
	children?: React.ReactNode;
	color?: StatusColor;
};

const Alert = ({ className, children, color = 'success', ...props }: Props) => {
	return (
		<AntdAlert className={cn(css.alert, css[color], className)} {...props} message={children ?? props.message} />
	);
};

export default Alert;
